<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/Monitor Quiz</span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
                <v-overlay :value="loader" absolute>
			Loading
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
            <v-card class="card" v-if="list_of_duties !=''">
            <v-card-title class="heading justify-center">
                <span><h3>Monitor Quiz</h3></span>
            </v-card-title>
                <v-card-text>
                    <template>
                    <v-data-table
                        :headers="headers"
                        :items="list_of_duties"
                        class="elevation-1"
                        :search="search"
                    >
                        <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Exam Time Table</v-toolbar-title>
                            <v-divider class="mx-10" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                            ></v-text-field>
                            <span style="width: 20px;"></span>
                        </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                        <v-btn v-if="item.enable_flag == true"
                            class="button"
                            @click="proceed(item)"
                        >Proceed</v-btn>
                        <v-btn disabled v-else class="button">Exam is not Active</v-btn>
                        </template>
                    </v-data-table>
                    </template>
                </v-card-text>
            </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    import loader from "sass-loader";
    import datetime from 'vuejs-datetimepicker'

    export default {
        components: {
            "vue-mathjax": VueMathjax,
            "datetime":datetime,
        },
        data() {
    return {
      ay_list: [],
      sem_list: [],
      exam_list: [],
      current_academic_year: "",
      current_semester: "",
      current_exam: "",
      list_of_duties: "",
      // list_of_exams: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      loader:false,
      headers: [
        { text: "Sr.No.", value: "srno" },
        { text: "Exam Name", value: "exam" },
        { text: "Quiz Name ", value: "quiz" },
        { text: "Exam Date ", value: "exam_date" },
        { text: "Slot No.", value: "slot_no" },
        { text: "Start Time", value: "start_time" },
        { text: "End Time", value: "end_time" },
        { text: "Division", value: "division" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
    };
  },
        mounted() {
            this.examtimetableid = this.$route.params.examtimetableid;
            const data = {
                examtimetableid: this.examtimetableid,
            };
            axios
                .post("QuizDashboard/fetchquizmonitoringdata",data)
                .then((res) => {
                    if (res.data.status == "200" && res.data.msg == "success") {
                        if (res.data.proctor_session_list != "") {
                            this.list_of_duties = res.data.proctor_session_list;
                        } else {
                            this.list_of_duties = "";
                            this.showSnackbar("#b71c1c", "Exam Time Table Data Not Found!"); // show snackbar
                        }
                    } else {
                        this.showSnackbar(res.data.msg, "#b71c1c");
                        this.dialog = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("Something Went Wrong...", "#b71c1c");
                    this.dialog = false;
                })
                .finally(() => {
                    this.dialog = false;
                });
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            proceed(val) {
            this.$store.commit('setproctor_session_id', val.id)
            this.$router.push({ name: 'quiz-live-dashboard'})
            window.open(routeData.href, '_blank');
            },
        },
    };
</script>
<style scoped>
     .label-row {
        display: flex;
        justify-content: space-between;
        margin: 0 10px;
        /* Equal margin on left and right sides */
    }

    .label-col {
        flex: 1;
        margin: 10px;
    }

    .red--text {
        color: red;
    }

    .font-weight-bold {
        font-weight: bold;
    }
    thead {
        background-color: rgb(91, 91, 248) !important;
    }
    .button {
    border: 2px solid hsla(190, 99%, 30%, 1) !important;
    color: rgb(1, 127, 152);
    background: transparent !important;
    border-radius: 50px;
}
</style>
